import BaseAPI from "@/apis/base/baseApi";

class LocationAPI extends BaseAPI {
  constructor() {
    super();
  }

  apiName = "TaskGo";
  controllerName = "Locations";
}

export default new LocationAPI();
